import { render, staticRenderFns } from "./InfoCenter.vue?vue&type=template&id=210d9665&"
import script from "./InfoCenter.vue?vue&type=script&lang=js&"
export * from "./InfoCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports